import React from 'react';
import { getWorkTypeName, getReviewStatusName } from './utils';
import TaskTitleLink from './TaskTitleLink';
import { ContentProps } from 'src/types/activityUpdate';

const CommunityReviewContent: React.FC<ContentProps> = ({
    user,
    workType,
    taskTitle,
    taskId,
    grossWorkTime,
    reviewStatus,
    seniorReviewerName
}) => {
    const workTypeText = workType ? getWorkTypeName(workType) : '';
    return (
        <>
            <strong>{user}</strong> solved <strong>{workTypeText}</strong> work{' '}
            <TaskTitleLink taskId={taskId} title={taskTitle} /> and marked it as{' '}
            <strong>
                {reviewStatus ? getReviewStatusName(reviewStatus) : ''}
            </strong>
            {grossWorkTime ? ` after ${grossWorkTime}.` : ''} <br />
            {seniorReviewerName
                ? `The next review is reserved to the quest breakdown solver: ${seniorReviewerName}`
                : ''}
        </>
    );
};

export default CommunityReviewContent;
